import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as echarts from "echarts"; // 引入 ECharts
import Element from "element-ui";
import XTComponents from "@xt-fe/xt-components";
import Brump from "@/components/Brump/index.vue";
Vue.component("Brump", Brump);
// import tippy from "tippy.js";
import "element-ui/lib/theme-chalk/index.css";
import "@xt-fe/xt-components/lib/theme/index.css";
import "./styles/index.css";
import MetaInfo from "vue-meta-info"; // 引入插件
Vue.use(MetaInfo); // 使用插件
// 引入 KaTeX CSS
import "katex/dist/katex.min.css";

// 引入 KaTeX JavaScript
import katex from "katex";
// 将 KaTeX 挂载到全局 window 对象上
window.katex = katex;

// import renderMathInElement from 'katex/dist/contrib/auto-render.mjs'
// window.renderMathInElement = renderMathInElement

const icons = require.context("./assets/icons", false, /\.svg$/);
for (const key of icons.keys()) {
  icons(key);
}
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
Vue.use(Element, { size: "small", zIndex: 3000 });
Vue.use(XTComponents);
Vue.config.productionTip = false;
import { stateFormat, stateFormatHj } from "./utils/util";
Vue.prototype.numberToCurrencyTwo = stateFormat;
Vue.prototype.numberToCurrencyTwoHj = stateFormatHj;
Vue.prototype.$echarts = echarts;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
